var Multiaddr = require('multiaddr');

var reduceValue = function reduceValue(_, v) {
  return v;
};

var tcpUri = function tcpUri(str, port, parts, opts) {
  // return tcp when explicitly requested
  if (opts && opts.assumeHttp === false) return "tcp://".concat(str, ":").concat(port); // check if tcp is the last protocol in multiaddr

  var protocol = 'tcp';
  var explicitPort = ":".concat(port);
  var last = parts[parts.length - 1];

  if (last.protocol === 'tcp') {
    // assume http and produce clean urls
    protocol = port === '443' ? 'https' : 'http';
    explicitPort = port === '443' || port === '80' ? '' : explicitPort;
  }

  return "".concat(protocol, "://").concat(str).concat(explicitPort);
};

var Reducers = {
  ip4: reduceValue,
  ip6: function ip6(str, content, i, parts) {
    return parts.length === 1 && parts[0].protocol === 'ip6' ? content : "[".concat(content, "]");
  },
  tcp: function tcp(str, content, i, parts, opts) {
    return parts.some(function (p) {
      return ['http', 'https', 'ws', 'wss'].includes(p.protocol);
    }) ? "".concat(str, ":").concat(content) : tcpUri(str, content, parts, opts);
  },
  udp: function udp(str, content) {
    return "udp://".concat(str, ":").concat(content);
  },
  dnsaddr: reduceValue,
  dns4: reduceValue,
  dns6: reduceValue,
  ipfs: function ipfs(str, content) {
    return "".concat(str, "/ipfs/").concat(content);
  },
  p2p: function p2p(str, content) {
    return "".concat(str, "/p2p/").concat(content);
  },
  http: function http(str) {
    return "http://".concat(str);
  },
  https: function https(str) {
    return "https://".concat(str);
  },
  ws: function ws(str) {
    return "ws://".concat(str);
  },
  wss: function wss(str) {
    return "wss://".concat(str);
  },
  'p2p-websocket-star': function p2pWebsocketStar(str) {
    return "".concat(str, "/p2p-websocket-star");
  },
  'p2p-webrtc-star': function p2pWebrtcStar(str) {
    return "".concat(str, "/p2p-webrtc-star");
  },
  'p2p-webrtc-direct': function p2pWebrtcDirect(str) {
    return "".concat(str, "/p2p-webrtc-direct");
  }
};

module.exports = function (multiaddr, opts) {
  var ma = Multiaddr(multiaddr);
  var parts = multiaddr.toString().split('/').slice(1);
  return ma.tuples().map(function (tuple) {
    return {
      protocol: parts.shift(),
      content: tuple[1] ? parts.shift() : null
    };
  }).reduce(function (str, part, i, parts) {
    var reduce = Reducers[part.protocol];
    if (!reduce) throw new Error("Unsupported protocol ".concat(part.protocol));
    return reduce(str, part.content, i, parts, opts);
  }, '');
};